export default "__VITE_ASSET__DaKqvTFh__"